import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'sm-button-transparent',
  templateUrl: './button-transparent.component.html'
})
export class ButtonTransparentComponent implements OnInit {

  @Input() label = '';

  isHoverd = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  onMouseOver() {
    this.isHoverd = true;
  }

  onMouseLeave() {
    this.isHoverd = false;
  }
}
